import "./scss/main.scss";
import { AppController } from "./components/controller/appController";
const app = new AppController();
app.start();
